"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SortableComponent;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _reactVirtuoso = require("react-virtuoso");

var _RecordCard = require("../RecordCard/RecordCard");

var _excluded = ["listRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ListContainer = (0, _styles.withStyles)(function () {
  return {
    root: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gridGap: 16,
      margin: 16
    },
    "@media (max-width: 960px)": {
      root: {
        gridTemplateColumns: "1fr 1fr"
      }
    }
  };
})(_Box2["default"]);
var ItemContainer = (0, _styles.withStyles)(function () {
  return {
    root: {
      width: "100%"
    }
  };
})(_Box2["default"]);
SortableComponent.propTypes = {
  atBottomStateChange: _propTypes["default"].func,
  totalCount: _propTypes["default"].number,
  itemContent: _propTypes["default"].func,
  onSortEnd: _propTypes["default"].func
};

function SortableComponent(_ref) {
  var atBottomStateChange = _ref.atBottomStateChange,
      totalCount = _ref.totalCount,
      itemContent = _ref.itemContent,
      _onSortEnd = _ref.onSortEnd;
  var ItemContainerSortable = (0, _reactSortableHoc.SortableElement)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(ItemContainer, props);
  });
  var ListContainerSortable = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
    var listRef = _ref2.listRef,
        props = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement(ListContainer, _extends({
      ref: listRef
    }, props));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "100%",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtuoso.VirtuosoGrid, {
    totalCount: totalCount,
    atBottomStateChange: atBottomStateChange,
    components: {
      List: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
        return /*#__PURE__*/_react["default"].createElement(ListContainerSortable, _extends({}, props, {
          pressDelay: 200,
          listRef: ref,
          axis: "xy",
          onSortStart: function onSortStart() {
            return document.body.style.cursor = "move";
          },
          onSortEnd: function onSortEnd(data) {
            document.body.style.cursor = "default";

            _onSortEnd(data);
          }
        }));
      }),
      Item: function Item(props) {
        var index = props["data-index"];
        return /*#__PURE__*/_react["default"].createElement(ItemContainerSortable, _extends({
          index: index
        }, props));
      }
    },
    itemContent: itemContent ? itemContent : function (index) {
      return /*#__PURE__*/_react["default"].createElement(_RecordCard.CardWrapper, null, "Item ", index);
    }
  }));
}